// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"f1967db22c9824b9a3c8","655":"f5287d2a7b59790e7a16"}[chunkId] + ".js";
};